import { render, staticRenderFns } from "./EvaluationTemplate.vue?vue&type=template&id=1df32a9d&scoped=true"
import script from "./EvaluationTemplate.vue?vue&type=script&lang=ts"
export * from "./EvaluationTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df32a9d",
  null
  
)

export default component.exports